export const environment = {
  web: true,
  production: false,
  drberndt: false,
  apptemp: false,
  logo: '../assets/images/Logo_00_Termed_Logo_Blau.png',
  logoalt: 'TerMed Logo',
  baseApiUrl: 'https://testapi.termed.de/v2/',
  baseUrl: 'https://testapi.termed.de/',
  docUrl: 'https://testdoc2023.termed.de/',
};

